import {createSlice} from '@reduxjs/toolkit'

const initialToken = () => {
    return null
}

export const tokenSlice = createSlice({
    name: 'token',
    initialState: {
        data: initialToken()
    },
    reducers: {
        setToken: (state, action) => {
            state['data'] = action.payload
        }
    }
})

export const {setToken} = tokenSlice.actions

export default tokenSlice.reducer